export default __webpack_public_path__ + "static/media/rightdandiya_2056.6babc7a3.png";